import { FeedbackBlockKind } from "@spscommerce/ds-shared";
import * as React from "react";

import { SpsCard, SpsMicroBlock } from "../index";

export const SpsMicroBlockPropTypes = SpsMicroBlock["propTypes"];

export class SpsMicroBlockWithInfo extends React.Component<{ "data-testid": any }> {
    static reactLive = {
        code: `
      <SpsCard>
            <SpsMicroBlock
              kind = "info"
            >
            Hey, here's something neat.
            </SpsMicroBlock>
      </SpsCard>
    `
    };

    render() {
        const { "data-testid": testId } = this.props;

        return (
            <SpsCard>
                <SpsMicroBlock kind={FeedbackBlockKind.INFO} data-testid={testId}>
                    Hey, here's something neat.
                </SpsMicroBlock>
            </SpsCard>
        );
    }
}

export class SpsMicroBlockWithSuccess extends React.Component<{ "data-testid": any }> {
    static reactLive = {
        code: `
          <SpsCard>
                <SpsMicroBlock
                  kind = "success"
                >
                That was amazing!
                </SpsMicroBlock>
          </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;

        return (
            <SpsCard>
                <SpsMicroBlock kind={FeedbackBlockKind.SUCCESS} data-testid={testId}>
                    That was amazing!
                </SpsMicroBlock>
            </SpsCard>
        );
    }
}

export class SpsMicroBlockWithWarning extends React.Component<{ "data-testid": any }> {
    static reactLive = {
        code: `
      <SpsCard>
            <SpsMicroBlock
              kind = "warning"
            >
            Watch yourself, Chester!
            </SpsMicroBlock>
      </SpsCard>
    `
    };

    render() {
        const { "data-testid": testId } = this.props;

        return (
            <SpsCard>
                <SpsMicroBlock kind={FeedbackBlockKind.WARNING} data-testid={testId}>
                    Watch yourself, Chester!
                </SpsMicroBlock>
            </SpsCard>
        );
    }
}

export class SpsMicroBlockWithError extends React.Component<{ "data-testid": any }> {
    static reactLive = {
        code: `
      <SpsCard>
            <SpsMicroBlock
              kind = "error"
            >
            Uh oh, Big problems.
            </SpsMicroBlock>
      </SpsCard>
    `
    };

    render() {
        const { "data-testid": testId } = this.props;

        return (
            <SpsCard>
                <SpsMicroBlock kind={FeedbackBlockKind.ERROR} data-testid={testId}>
                    Uh oh, Big problems.
                </SpsMicroBlock>
            </SpsCard>
        );
    }
}

export class SpsMicroBlockWithTip extends React.Component<{ "data-testid": any }> {
    static reactLive = {
        code: `
      <SpsCard>
            <SpsMicroBlock
              kind = "tip"
            >
            Pro Tip: Don't be a loser.
            </SpsMicroBlock>
      </SpsCard>
    `
    };

    render() {
        const { "data-testid": testId } = this.props;

        return (
            <SpsCard>
                <SpsMicroBlock kind={FeedbackBlockKind.TIP} data-testid={testId}>
                    Pro Tip: Don't be a loser.
                </SpsMicroBlock>
            </SpsCard>
        );
    }
}
